import * as React from 'react';
import styled from 'styled-components';
import { Dropdown, Menu, Icon } from 'antd';
import theme from 'theme';
import t from 'utils/translations';

import { CommonRouterLink } from 'components/common';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { AppContext } from 'components/context';
import { Redirect } from 'react-router';

const MenuButton = styled.button`
    align-items: center;
    background-color: transparent;
    border: 0;
    display: flex;
    height: 100%;
    margin: 0 5px;

    svg {
        margin-right: 10px;
        margin-left: 10px;
    }
`;

const MenuWrapper = styled(Menu)`
    .ant-dropdown-menu-item i {
        margin-right: 8px;
    }
`;

const Link = styled(CommonRouterLink)`
    margin: 0 10px;
`;

const Arrow = styled.div`
    margin: 0 8px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${theme.colors.main};
`;

export default function LoginComponent() {
    const context = React.useContext(AppContext);
    const [redirectToLogin, setRedirectToLogin] = React.useState(false);
    if (!context) return null;

    const { firstName, endUserId, authenticated } = context.state.auth;

    const logout = () => {
        context.actions.logout();
        setRedirectToLogin(true);
    };

    const userMenu = (
        <MenuWrapper>
            <Menu.Item onClick={logout}>
                <Icon type="logout" />
                Kirjaudu ulos
            </Menu.Item>
        </MenuWrapper>
    );

    if (redirectToLogin) {
        return <Redirect to="/kirjaudu-sisaan" />;
    }

    return (
        <div>
            {authenticated ? (
                <Dropdown overlay={userMenu} trigger={['click']}>
                    <MenuButton>
                        <UserIcon height={20} />
                        {firstName
                            ? firstName
                            : endUserId
                            ? endUserId
                            : t('USER')}
                        <Arrow />
                    </MenuButton>
                </Dropdown>
            ) : (
                <Link to="/kirjaudu-sisaan">{t('LOGIN')}</Link>
            )}
        </div>
    );
}
